/**
 * WebSocket 基础封装
 * 支持多平台兼容性基础（虽然目前主要针对 Web）
 */
export class YNWebsocket {
    addr!: string;
    ws!: WebSocket | any;
    destory: boolean = false;
    platform: any;

    constructor( addr: string, platform?: any ) {
        this.addr = addr;
        this.platform = platform;

        if ( this.platform && typeof this.platform.connectSocket === "function" ) {
            console.log( "Using platform-specific WebSocket" );
            this.ws = this.platform.connectSocket( {
                url: addr,
                success: () => console.log( "WebSocket opened successfully" ),
                fail: () => console.log( "Failed to open WebSocket" ),
            } );
        } else {
            console.log( "Using native WebSocket" );
            this.ws = new WebSocket( this.addr );
        }
    }

    onopen( callback: () => void ) {
        if ( this.platform && typeof this.ws.onOpen === "function" ) {
            this.ws.onOpen( () => {
                if ( !this.destory && callback ) callback();
            } );
        } else {
            this.ws.onopen = () => {
                if ( !this.destory && callback ) callback();
            };
        }
    }

    onmessage( callback: (( ev: MessageEvent ) => any) | null ) {
        if ( this.platform && typeof this.ws.onMessage === "function" ) {
            this.ws.onMessage( ( e: any ) => {
                if ( !this.destory && callback ) callback( e.data );
            } );
        } else {
            this.ws.onmessage = ( e: any ) => {
                if ( !this.destory && callback ) callback( e.data );
            };
        }
    }

    onclose( callback: ( e: CloseEvent ) => void ) {
        if ( this.platform && typeof this.ws.onClose === "function" ) {
            this.ws.onClose( ( params: any ) => {
                if ( !this.destory && callback ) callback( params );
            } );
        } else {
            this.ws.onclose = ( e: any ) => {
                if ( !this.destory && callback ) callback( e );
            };
        }
    }

    onerror( callback: ( e: Event ) => void ) {
        if ( this.platform && typeof this.ws.onError === "function" ) {
            this.ws.onError( ( e: any ) => {
                if ( !this.destory && callback ) callback( e );
            } );
        } else {
            this.ws.onerror = ( e: any ) => {
                if ( !this.destory && callback ) callback( e );
            };
        }
    }

    send( data: any ) {
        if ( this.platform && typeof this.ws.send === "function" ) {
            if ( data instanceof Uint8Array ) {
                this.ws.send( { data: data.buffer } );
            } else {
                this.ws.send( { data } );
            }
        } else {
            if ( this.ws.readyState !== WebSocket.OPEN ) {
                console.warn( "WebSocket not connected, cannot send message: ", this.ws.readyState );
                return;
            }
            this.ws.send( data );
        }
    }

    close() {
        this.destory = true;
        this.ws.close();
    }
}
